import React, { useEffect } from 'react';
import { FeatureFlagsEnum } from './FeatureFlags.enum';
import { useDispatch } from 'react-redux';
import { LoadUserSummaryFromStorage } from '../../slices/user-summary/load-user-summary-from-storage';
import { useFeatureFlag } from '../../custom-hooks/useFeatureFlag';

interface FeatureFlagProps {
    flag: FeatureFlagsEnum;
    children: React.ReactNode;
}

export const FeatureFlag = (props: FeatureFlagProps) => {
    const dispatch: any = useDispatch();
    useEffect(() => {
        dispatch(LoadUserSummaryFromStorage());
    }, []);
    const isEnabled = useFeatureFlag(props.flag);

    return <>{isEnabled ? props.children : []}</>;
};
